import { State } from "./types";
/*
 * define state here
 */
export default (): State => ({
  isLoading: false,
});
